var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vkb_nak vkb_nak_spv vkb_nak_index" }, [
    _c("div", { staticClass: "row" }, [
      !_vm.config.index_name
        ? _c(
            "div",
            { staticClass: "large-12 columns" },
            [
              _c("div", { staticClass: "row wrapper-spacing pb-0" }, [
                _c("div", { staticClass: "medium-12 large-12 columns" }, [
                  _c("h1", [_vm._v("Wählen Sie Ihren Index")]),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Indizes")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "spv-select-group row" },
                    _vm._l(_vm.product_variants, function(product_variant) {
                      return _c(
                        "div",
                        {
                          key: product_variant.id,
                          class: "col-variant columns"
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "spv-select-group__option",
                                {
                                  selected:
                                    _vm.product_variant_.id ===
                                    product_variant.id
                                }
                              ],
                              on: {
                                click: function($event) {
                                  _vm.product_variant_ = product_variant
                                }
                              }
                            },
                            [
                              _c("h3", {
                                staticClass: "caption",
                                domProps: {
                                  innerHTML: _vm._s(product_variant.label)
                                }
                              })
                            ]
                          )
                        ]
                      )
                    })
                  )
                ])
              ]),
              _vm._v(" "),
              _c("spv-general", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "trend",
                    expression: "product_variant_.id === 'trend'"
                  }
                ],
                attrs: { "index-id": "trend", "show-style": _vm.show_style }
              }),
              _vm._v(" "),
              _c("spv-trend", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "trend-old",
                    expression: "product_variant_.id === 'trend-old'"
                  }
                ],
                attrs: { "index-id": "trend-old", "show-style": _vm.show_style }
              }),
              _vm._v(" "),
              _c("spv-general", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "deka",
                    expression: "product_variant_.id === 'deka'"
                  }
                ],
                attrs: { "index-id": "deka", "show-style": _vm.show_style }
              }),
              _vm._v(" "),
              _c("spv-deka", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "deka-old",
                    expression: "product_variant_.id === 'deka-old'"
                  }
                ],
                attrs: { "index-id": "deka-old", "show-style": _vm.show_style }
              }),
              _vm._v(" "),
              _c("spv-general", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "climate",
                    expression: "product_variant_.id === 'climate'"
                  }
                ],
                attrs: { "index-id": "climate", "show-style": _vm.show_style }
              }),
              _vm._v(" "),
              _c("spv-climate", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "climate-old",
                    expression: "product_variant_.id === 'climate-old'"
                  }
                ],
                attrs: {
                  "index-id": "climate-old",
                  "show-style": _vm.show_style
                }
              }),
              _vm._v(" "),
              _c("spv-general", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "euro",
                    expression: "product_variant_.id === 'euro'"
                  }
                ],
                attrs: { "index-id": "euro", "show-style": _vm.show_style }
              }),
              _vm._v(" "),
              _c("spv-general", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.product_variant_.id === "vola",
                    expression: "product_variant_.id === 'vola'"
                  }
                ],
                attrs: { "index-id": "vola", "show-style": _vm.show_style }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "large-12 columns" },
            [
              _vm.config.index_name === "trend"
                ? _c("spv-general", {
                    attrs: { "index-id": "trend", "show-style": _vm.show_style }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "trend-old"
                ? _c("spv-trend", {
                    attrs: {
                      "index-id": "trend-old",
                      "show-style": _vm.show_style
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "deka"
                ? _c("spv-general", {
                    attrs: { "index-id": "deka", "show-style": _vm.show_style }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "deka-old"
                ? _c("spv-deka", {
                    attrs: {
                      "index-id": "deka-old",
                      "show-style": _vm.show_style
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "climate"
                ? _c("spv-general", {
                    attrs: {
                      "index-id": "climate",
                      "show-style": _vm.show_style
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "climate-old"
                ? _c("spv-climate", {
                    attrs: {
                      "index-id": "climate-old",
                      "show-style": _vm.show_style
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "euro" ||
              _vm.config.index_name === "euro_2"
                ? _c("spv-general", {
                    attrs: { "index-id": "euro", "show-style": _vm.show_style }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.config.index_name === "vola" ||
              _vm.config.index_name === "vola_2"
                ? _c("spv-general", {
                    attrs: { "index-id": "vola", "show-style": _vm.show_style }
                  })
                : _vm._e()
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f098df90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f098df90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/spv.vue
// module id = PIJf
// module chunks = 0